import type { MetaFunction } from "@remix-run/cloudflare";

export const TITLE_SUFFIX = " | OURPR"

export const DEFAULT_TITLE = "OURPR"
export const DEFAULT_DESCRIPTION = "OURPR(アワー ・ピーアール)は、より気軽に、より自由に、みんなでより楽しくPR活動を行うためのプラットフォームです。"

export const DEFAULT_META: MetaFunction = () => {
  return [
    { title: DEFAULT_TITLE },
    {
      name: "description", content:
        DEFAULT_DESCRIPTION
    },
  ];
};

export const COMMENT_PER_PAGE = 12;

export const PR_COLORS = [
  "bg-pr-red",
  "bg-pr-green",
  "bg-pr-blue",
  "bg-pr-orange",
];

export const MAIN_COLORS = [
  "#4CAF50",
  "#F24E1E",
  "#1877F2",
  "#FFA200",
]
export const getRandomMainColor = () => {
  return MAIN_COLORS[Math.floor(Math.random() * MAIN_COLORS.length)];
}

export const BUSINESS_TYPES = [
  { num: 0, name: "パソコン・周辺機器" },
  { num: 1, name: "パソコンソフトウェア" },
  { num: 2, name: "プロバイダ・回線接続" },
  { num: 3, name: "ネットサービス" },
  { num: 4, name: "スマートフォンアプリ" },
  { num: 5, name: "スマートフォンゲーム" },
  { num: 6, name: "モバイル端末" },
  { num: 7, name: "カメラ" },
  { num: 8, name: "AV機器" },
  { num: 9, name: "調理・生活家電" },
  { num: 10, name: "健康・美容家電" },
  { num: 11, name: "サーバ・周辺機器" },
  { num: 12, name: "ネットワーク・ネットワーク機器" },
  { num: 13, name: "アプリケーション・セキュリティ" },
  { num: 14, name: "システム・Webサイト・アプリ開発" },
  { num: 15, name: "電子部品・半導体・電気機器" },
  { num: 16, name: "百貨店・スーパー・コンビニ・ストア" },
  { num: 17, name: "EC・通販" },
  { num: 18, name: "卸売・問屋" },
  { num: 19, name: "芸能" },
  { num: 20, name: "映画・演劇・DVD" },
  { num: 21, name: "音楽" },
  { num: 22, name: "テレビ・CM" },
  { num: 23, name: "雑誌・本・出版物" },
  { num: 24, name: "漫画・アニメ" },
  { num: 25, name: "アート・カルチャー" },
  { num: 26, name: "コンシューマーゲーム" },
  { num: 27, name: "アーケードゲーム" },
  { num: 28, name: "おもちゃ・遊具・人形" },
  { num: 29, name: "スポーツ" },
  { num: 30, name: "アウトドア・登山" },
  { num: 31, name: "自動車・カー用品" },
  { num: 32, name: "バイク・バイク用品" },
  { num: 33, name: "インテリア・家具・収納" },
  { num: 34, name: "日用品・生活雑貨" },
  { num: 35, name: "ガーデン・DIY" },
  { num: 36, name: "レディースファッション" },
  { num: 37, name: "メンズファッション" },
  { num: 38, name: "シューズ・バッグ" },
  { num: 39, name: "ジュエリー・アクセサリー" },
  { num: 40, name: "キッズ・ベビー・マタニティ" },
  { num: 41, name: "食品・お菓子" },
  { num: 42, name: "ソフトドリンク・アルコール飲料" },
  { num: 43, name: "レストラン・ファストフード・居酒屋" },
  { num: 44, name: "中食・宅配" },
  { num: 45, name: "スキンケア・化粧品・ヘア用品" },
  { num: 46, name: "ダイエット・健康食品・サプリメント" },
  { num: 47, name: "フィットネス・ヘルスケア" },
  { num: 48, name: "医療・病院" },
  { num: 49, name: "医薬・製薬" },
  { num: 50, name: "福祉・介護・リハビリ" },
  { num: 51, name: "ペット・ペット用品" },
  { num: 52, name: "ギフト・花" },
  { num: 53, name: "恋愛・結婚" },
  { num: 54, name: "出産・育児" },
  { num: 55, name: "葬儀" },
  { num: 56, name: "ホテル・旅館" },
  { num: 57, name: "旅行・観光" },
  { num: 58, name: "テーマパーク・遊園地" },
  { num: 59, name: "住宅・マンション" },
  { num: 60, name: "商業施設・オフィスビル" },
  { num: 61, name: "建築・空間デザイン" },
  { num: 62, name: "建設・土木" },
  { num: 63, name: "就職・転職・人材派遣・アルバイト" },
  { num: 64, name: "資格・留学・語学" },
  { num: 65, name: "学校・大学" },
  { num: 66, name: "学習塾・予備校・通信教育" },
  { num: 67, name: "保育・幼児教育" },
  { num: 68, name: "銀行・信用金庫・信用組合" },
  { num: 69, name: "クレジットカード・ローン" },
  { num: 70, name: "証券・FX・投資信託" },
  { num: 71, name: "生命保険・損害保険" },
  { num: 72, name: "広告・宣伝・PR" },
  { num: 73, name: "マーケティング・リサーチ" },
  { num: 74, name: "セールス・営業" },
  { num: 75, name: "経営・コンサルティング" },
  { num: 76, name: "シンクタンク" },
  { num: 77, name: "財務・経理" },
  { num: 78, name: "法務・特許・知的財産" },
  { num: 79, name: "交通・運送・引越し" },
  { num: 80, name: "物流・倉庫・貨物" },
  { num: 81, name: "鉄鋼・金属・ガラス・土石・ゴム" },
  { num: 82, name: "化学" },
  { num: 83, name: "電気・ガス・資源・エネルギー" },
  { num: 84, name: "自然・天気" },
  { num: 85, name: "環境・エコ・リサイクル" },
  { num: 86, name: "政治・官公庁・地方自治体" },
  { num: 87, name: "財団法人・社団法人・宗教法人" },
  { num: 88, name: "ボランティア" },
  { num: 89, name: "国際情報・国際サービス" },
  { num: 90, name: "農林・水産" },
  { num: 91, name: "その他" }
];

export const getBusinessType = (num: number) => {
  return BUSINESS_TYPES.find((type) => type.num === num)?.name;
}


export const LISTING_STATUS = [
  { num: 0, name: "未上場" },
  { num: 16, name: "東証プライム" },
  { num: 17, name: "東証スタンダード" },
  { num: 18, name: "東証グロース" },
  { num: 19, name: "名証プレミア" },
  { num: 20, name: "名証メイン" },
  { num: 21, name: "名証ネクスト" },
  { num: 7, name: "札証" },
  { num: 8, name: "福証" },
  { num: 98, name: "その他国内市場" },
  { num: 99, name: "海外市場" },
]

export const getListingStatus = (num: number) => {
  return LISTING_STATUS.find((status) => status.num === num)?.name;
}
